import { render, staticRenderFns } from "./SecurityRoles.vue?vue&type=template&id=79ff7c24&scoped=true&"
import script from "./SecurityRoles.vue?vue&type=script&lang=js&"
export * from "./SecurityRoles.vue?vue&type=script&lang=js&"
import style0 from "./SecurityRoles.vue?vue&type=style&index=0&id=79ff7c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff7c24",
  null
  
)

export default component.exports